export default (str) => {

  if (!str)
    return ""

  return str
        .replace(/[ÀÁÂÃÄÅ]/g, "A")
        .replace(/[àáâãäå]/g, "a")
        .replace(/[ÈÉÊË]/g, "E")
        .replace(/[èéêë]/g, "e")
        .replace(/[ÌÍÎÏ]/g, "I")
        .replace(/[ìíîï]/g, "i")
        .replace(/[ÒÓÔÕÖ]/g, "O")
        .replace(/[òóôõöº]/g, "o")
        .replace(/[ÙÚÛÜ]/g, "U")
        .replace(/[ùúûü]/g, "u")
        .replace(/[Ç]/g, "C")
        .replace(/[ç]/g, "c")
        .replace(/[Ñ]/g, "N")
        .replace(/[ñ]/g, "n")       
        .replace(/\uFFFD/g, "") 
        .trim()
}